export default "__VITE_ASSET__bIbnPgqb__"